/** XeAgents.ai**/
import type { ReactNode } from "react";

interface LandingSectionProps {
  /** Anchor target used by the navbar links. */
  id?: string;
  label: string;
  /**
   * schema.org type for the section, e.g. "ItemList" or "HowTo". Omitting it
   * renders a plain section with no microdata scope.
   */
  schemaType?: string;
  /** Extra classes, mainly the AEO hooks ("hero-description", "key-features"). */
  className?: string;
  itemProp?: string;
  children: ReactNode;
}

/**
 * Wraps a landing-page block in the semantic markup search and answer engines
 * read, so the page component stays a readable list of sections instead of
 * repeating the same six microdata attributes ten times over.
 */
export function LandingSection({
  id,
  label,
  schemaType,
  className,
  itemProp,
  children,
}: LandingSectionProps) {
  const schemaProps = schemaType
    ? { itemScope: true, itemType: `https://schema.org/${schemaType}` }
    : {};

  return (
    <section
      id={id}
      aria-label={label}
      className={className}
      itemProp={itemProp}
      {...schemaProps}
    >
      {children}
    </section>
  );
}

export default LandingSection;
